import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate'
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(private translate: TranslateService) { }

  transform(date: any, pattern: string = 'mediumDate'): any {
    const currentLang = this.translate.currentLang;

    return new DatePipe(currentLang).transform(date, pattern);
  }

}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/shared/pipes/localized-date.pipe.ts